import React from "react"

import Nav from "../components/nav"

import "../scss/layouts/common.scss"
import "../scss/components/layout.scss"

class Layout extends React.Component {
  render() {
    const { children } = this.props

    return (
      <div className="container">
        <Nav location={this.props.location} title={this.props.title} />
        <div className="wrap">{children}</div>
        <footer className="footer">
        Copyright - Kentaro Koga, {new Date().getFullYear()} All Rights Reserved.
        </footer>
      </div>
    )
  }
}

export default Layout
